import { Container, useTheme } from '@mui/material';
import { getStyled } from './styles';

const MainContainer = ({ children }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  return (
    <Container sx={classes.mainContainer}>
      <div style={classes.contentWrapper}>{children}</div>
    </Container>
  );
};

export default MainContainer;
